import React from 'react';
import AnimatedScore from './AnimatedScore';
import SetsWon from './SetsWon';
import { getContrastTextColor } from '../utils/contrast';
import { Minus, Plus, Palette } from 'phosphor-react';

export default function TeamPanel({
  teamName,
  setTeamName,
  teamColor,
  setTeamColor,
  teamScore,
  setTeamScore,
  setsWon,
  side = 'A',
  readOnly = false,
  animate = true,
}) {
  const textColor = getContrastTextColor(teamColor);

  return (
    <div className={`team-block team-${side}`} style={{ backgroundColor: teamColor, color: textColor }}>
      <div className="team-inner">
        <div className="team-header">
          {readOnly ? (
            <div
              className="team-name"
              style={{
                color: textColor,
                background: 'transparent',
                textAlign: 'center',
                fontSize: '4rem',
                fontWeight: 500,
                width: '100%',
              }}
            >
              {teamName || `Team ${side}`}
            </div>
          ) : (
            <input
              className="team-name"
              value={teamName || ''}
              onChange={(e) => setTeamName(e.target.value)}
              onMouseDown={(e) => {
                if (document.activeElement === e.target) e.preventDefault();
              }}
              onFocus={(e) => {
                setTimeout(() => e.target.select(), 0);
              }}
              style={{
                color: textColor,
                background: 'transparent',
                border: 'none',
                textAlign: 'center',
                fontSize: '4rem',
                fontWeight: 500,
                width: '100%',
                outline: 'none',
              }}
              placeholder={`Team ${side}`}
              spellCheck={false}
            />
          )}
        </div>

        <div className="score-container">
          {!readOnly && (
            <button
              className="score-controller"
              style={{ color: textColor }}
              onClick={() => setTeamScore((prev) => Math.max(0, prev - 1))}
            >
              <Minus size={36} weight="fill" color={textColor} />
            </button>
          )}

          <AnimatedScore value={teamScore} animate={animate} />

          {!readOnly && (
            <button
              className="score-controller"
              style={{ color: textColor }}
              onClick={() => setTeamScore((prev) => prev + 1)}
            >
              <Plus size={36} weight="fill" color={textColor} />
            </button>
          )}
        </div>

        <div className="team-footer">
            {!readOnly && (
            <div className="team-settings">
                <input
                    type="color"
                    value={teamColor}
                    onChange={(e) => setTeamColor(e.target.value)}
                    className="color-input"
                />
                <span className="color-icon" style={{ color: textColor }} role="img" aria-label="color">
                  <Palette size={20} weight="fill" color={textColor} />
                </span>
            </div>
          )}

          <div className="set-container">
            <SetsWon setsWon={setsWon} />
          </div>
        </div>
      </div>
    </div>
  );
}